import axios from "axios";
import BASE_URL from "../../config";

const getAuthHeader = () => {
    const token = localStorage.getItem("token");
    return {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
    };
};

// --- Account Master ---
export const getAccountMasters = async () => {
    try {
        const response = await axios.get(`${BASE_URL}/api/Finance/masters`, {
            headers: getAuthHeader(),
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching account masters:", error);
        throw error;
    }
};

// --- Account Head ---
export const getAccountHeads = async (masterId = null) => {
    try {
        const url = masterId 
            ? `${BASE_URL}/api/Finance/heads?masterId=${masterId}` 
            : `${BASE_URL}/api/Finance/heads`;
        const response = await axios.get(url, {
            headers: getAuthHeader(),
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching account heads:", error);
        throw error;
    }
};

export const saveAccountHead = async (head) => {
    try {
        const response = await axios.post(`${BASE_URL}/api/Finance/heads`, head, {
            headers: getAuthHeader(),
        });
        return response.data;
    } catch (error) {
        console.error("Error saving account head:", error);
        throw error;
    }
};

export const getNextAccountHeadCode = async (masterId) => {
    try {
        const response = await axios.get(`${BASE_URL}/api/Finance/next-head-code?masterId=${masterId}`, {
            headers: getAuthHeader(),
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching next account head code:", error);
        throw error;
    }
};

// --- Account Sub Head ---
export const getAccountSubHeads = async (headId = null) => {
    try {
        const url = headId 
            ? `${BASE_URL}/api/Finance/subheads?headId=${headId}` 
            : `${BASE_URL}/api/Finance/subheads`;
        const response = await axios.get(url, {
            headers: getAuthHeader(),
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching account sub-heads:", error);
        throw error;
    }
};

export const saveAccountSubHead = async (subHead) => {
    try {
        const response = await axios.post(`${BASE_URL}/api/Finance/subheads`, subHead, {
            headers: getAuthHeader(),
        });
        return response.data;
    } catch (error) {
        console.error("Error saving account sub-head:", error);
        throw error;
    }
};

export const getNextAccountSubHeadCode = async (headId) => {
    try {
        const response = await axios.get(`${BASE_URL}/api/Finance/next-subhead-code?headId=${headId}`, {
            headers: getAuthHeader(),
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching next account sub-head code:", error);
        throw error;
    }
};

// --- ASH Mapping ---
export const getAshMappings = async () => {
    try {
        const response = await axios.get(`${BASE_URL}/api/Finance/mappings`, { headers: getAuthHeader() });
        return response.data;
    } catch (error) {
        console.error("Error fetching mappings:", error);
        throw error;
    }
};

export const getAshMappingMasters = async () => {
    try {
        const response = await axios.get(`${BASE_URL}/api/Finance/mapping-masters`, { headers: getAuthHeader() });
        return response.data;
    } catch (error) {
        console.error("Error fetching mapping masters:", error);
        throw error;
    }
};

export const saveAshMapping = async (mapping) => {
    try {
        const response = await axios.post(`${BASE_URL}/api/Finance/mappings`, mapping, { headers: getAuthHeader() });
        return response.data;
    } catch (error) {
        console.error("Error saving mapping:", error);
        throw error;
    }
};

export const deleteAshMapping = async (subHeadId, code) => {
    try {
        const response = await axios.delete(`${BASE_URL}/api/Finance/mappings?subHeadId=${subHeadId}&code=${code}`, { headers: getAuthHeader() });
        return response.data;
    } catch (error) {
        console.error("Error deleting mapping:", error);
        throw error;
    }
};
